import { render, staticRenderFns } from "./PageCustomerInput.vue?vue&type=template&id=0678e782&scoped=true"
import script from "./PageCustomerInput.vue?vue&type=script&lang=js"
export * from "./PageCustomerInput.vue?vue&type=script&lang=js"
import style0 from "./PageCustomerInput.vue?vue&type=style&index=0&id=0678e782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678e782",
  null
  
)

export default component.exports